import React from 'react';
import styled from 'styled-components';
import {hover, white} from "../styles/globalStyleVars";
import {Link} from "react-router-dom";


const Button = ({
                    onSubmit,
                    text,
                    src,
                    img,
                    hoverImg,
                    fontSize,
                    fontWeight,
                    color,
                    letterSpacing,
                    lineHeight,
                    margin,
                    marginMobile,
                    background,
                    borderRadius,
                    border,
                    width,
                    height,
                    hoverBackground,
                    target,
                    borderColor,
                    hoverColor,
                    hoverBorderColor,
                    onClick,download,file,icon
                }) => {


    return (
        <StyledBtn className={`dc-btn fade-up`}
                   fontSize={fontSize}
                   fontWeight={fontWeight}
                   color={color}
                   background={background}
                   lineHeight={lineHeight}
                   letterSpacing={letterSpacing}
                   margin={margin}
                   marginMobile={marginMobile}
                   border={border}
                   img={img}
                   borderRadius={borderRadius}
                   width={width}
                   hoverImg={hoverImg}
                   hoverBackground={hoverBackground}
                   height={height}
                   borderColor={borderColor}
                   target={target}
                   hoverColor={hoverColor}
                   hoverBorderColor={hoverBorderColor}
                   onSubmit={onSubmit}
                   onClick={onClick}
        >
            {
                download? <a href={`${file}`} target={'_blank'} download>
                        <span> {text}  </span>
                    </a> :
                    <>
                        {src ?
                            <Link onClick={onClick} to={src}>
                                <span> {text}  </span>
                                {
                                    icon?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
                                            <g id="Group_24648" data-name="Group 24648" transform="translate(-653 -1595.793)">
                                                <g id="Group_4823" data-name="Group 4823" transform="translate(11 4)">
                                                    <line id="Line_9" data-name="Line 9" x2="5" y2="5" transform="translate(647.5 1592.5)" fill="none" stroke="#142637" stroke-linecap="round" stroke-width="1"/>
                                                    <line id="Line_10" data-name="Line 10" x1="5" y2="5" transform="translate(647.5 1597.5)" fill="none" stroke="#142637" stroke-linecap="round" stroke-width="1"/>
                                                </g>
                                                <line id="Line_11" data-name="Line 11" x2="10" transform="translate(653.5 1601.5)" fill="none" stroke="#142637" stroke-linecap="round" stroke-width="1"/>
                                            </g>
                                        </svg> : ''

                                }
                            </Link>
                            :
                            <Link onClick={onClick} to={'/'} onClick={e => e.preventDefault()}>
                                <span> {text}  </span>
                            </Link>
                        }
                    </>
            }




        </StyledBtn>
    )
};

const StyledBtn = styled.div`
  &.dc-btn {
    margin: ${props => props.margin || '0'};
    width: ${props => props.width || 'fit-content'};
    height: ${props => props.height || '40'}px;
    cursor: pointer;

    a {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;
      font-size: ${props => props.fontSize || '16'}px;
      font-weight: ${props => props.fontWeight || 500};
      margin: 0;
      line-height: ${props => props.lineHeight || '24'}px;
      background-color: ${props => props.background || 'transparent'};
      position: relative;
      border-radius: ${props => props.borderRadius || '24'}px;
      overflow: hidden;
      z-index: 0;
      transition: border .3s ease;
      padding: 12px 36px;
      box-sizing: border-box;
      border: ${p => p.border};
      
      svg{
        margin-left: 12px;
      }

      span {
        transition: color .3s ease;
        color: ${props => props.color || `#FFF`};
        position: relative;
        z-index: 2;
        width: max-content;
      }


      &:before {
        top: 100%;
        content: "";
        display: block;
        position: absolute;
        right: 0;
        left: 0;
        background-color: ${p => p.hoverBackground || hover};
        height: 100%;
        width: 100%;
        margin: auto;
        transition: all .5s ease;
        border-radius: 24px;
      }

      &:hover {
        svg{
          z-index: 1000;
          g{
            line{
              stroke: ${white};
            }
          }
        }
        span {
          color: ${props => props.hoverColor || `#FFF`};
        }

        &:before {
          top: 0
        }

        border-color: ${p => p.hoverBorderColor};
      }

      &:focus {
        color: #222222;
      }
    }

    @media (max-width: 767px) {
      margin: ${p => p.marginMobile};
    }
  }



`;


export default Button;
